// @ts-nocheck


import queryString from 'query-string';





import {
  convertFromKopToRub,
  convertFromRubToKop,
  convertFromMToKm,
  convertFromKmToM,
  convertFromSecondToHour,
  convertFromHourToSecond } from
'../pure/unitConversions';
import { convertDataFromServer as convertDataFromServerGroupedList } from './executionBudget';
import { convertDataFromServer as vehicleConvertDataFromServer } from './vehicle';

import {
  fetchRequest,
  initialFetchListParams,
  downloadRequestWithToken } from
'./index';


const convertDataFromServer = (mantenance) => ({
  ...mantenance,
  kilometrage: convertFromMToKm(mantenance.kilometrage),
  workEngineHours: convertFromSecondToHour(mantenance?.workEngineHours ?? 0),
  plannedKilometrage: convertFromMToKm(mantenance.plannedKilometrage),
  totalSum: convertFromKopToRub(mantenance.totalSum),
  vehicle: mantenance?.vehicle ?
  vehicleConvertDataFromServer(mantenance.vehicle) :
  null
});

const convertDataToServer = (mantenance) => ({
  ...mantenance,
  kilometrage: convertFromKmToM(mantenance.kilometrage),
  workEngineHours: convertFromHourToSecond(mantenance?.workEngineHours ?? 0),
  plannedKilometrage: convertFromKmToM(mantenance.plannedKilometrage),
  totalSum: convertFromRubToKop(mantenance.totalSum)
});

export const addMaintenance = async (
maintenance) =>
{
  const added = await fetchRequest.post(
    '/maintenance',
    convertDataToServer(maintenance)
  );
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось создать ремонт');
};

export const updateMaintenance = async (
maintenance) =>
{
  const updated = await fetchRequest.put(
    '/maintenance',
    convertDataToServer(maintenance)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить ремонт');
};

export const fetchMaintenance = async (
id,
params = {}) =>

convertDataFromServer(await fetchRequest.get(`/maintenance/${id}`, params));

export const deleteMaintenance = async (id) => {
  const deleted = await fetchRequest.delete(`/maintenance/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить ремонт');
};

export const fetchMaintenances = async (
params = initialFetchListParams) =>
{
  const maintenances = await fetchRequest.get('/maintenance', {
    ...initialFetchListParams,
    ...params
  });
  if (maintenances)
  return {
    ...maintenances,
    data: maintenances.data.map(convertDataFromServer)
  };
  throw new Error(
    'Не удалось получить сгруппированный список для исполнения бюджета'
  );
};

export const printMaintenance = async (id) => {
  const print = await downloadRequestWithToken(`/maintenance/${id}/print`);
  if (print) return print;
  throw new Error('Не удалось загрузить файл');
};

export const print = async (params, filename) => {
  const print = await downloadRequestWithToken(
    `/maintenance/print`,
    params,
    filename
  );
  if (print) return print;
  throw new Error('Не удалось загрузить файл');
};

export const changeCountStockPart = async (
id,
status) =>
{
  const updated = await fetchRequest.put(
    '/maintenance/changeCountStockPart',
    {
      id,
      status
    }
  );
  if (updated) return updated;
  throw new Error('Не удалось обновить остаток запчастей');
};

export const changeStatusMaintenance = async (
id,
status) =>
{
  const updated = await fetchRequest.post('/maintenance/changeStatus', {
    id,
    status
  });
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить статус');
};

export const getMaintenanceExpenseDirection = async (params) => {
  const expenseDirection = fetchRequest.get(
    '/maintenance/getExpenseDirection',
    params
  );
  if (expenseDirection) return expenseDirection;
  throw new Error('Не удалось найти направление расходов');
};

export const updateAct = async (
params,
data) =>
{
  const maintenance = await fetchRequest.put(
    `/maintenance/updateActId?${queryString.stringify(params)}`,
    data
  );
  if (maintenance) {
    return maintenance;
  }
  throw new Error('Не удалось закрепить акт за списоком замен гос. номеров');
};

export const getTotalSum = async (params = {}) => {
  const sum = await fetchRequest.get(`/maintenance/totalSum`, params);
  if (sum || sum === 0) return convertFromKopToRub(sum);
  throw new Error('Не удалось получить общую сумму');
};

export const groupedList = async (
params = {}) =>
{
  const groupedList = await fetchRequest.get(
    `/maintenance/groupedList`,
    params
  );
  if (groupedList)
  return {
    ...groupedList,
    data: groupedList.data.map(convertDataFromServerGroupedList)
  };
  throw new Error(
    'Не удалось получить сгруппированный список для исполнения бюджета'
  );
};

export const fillNextToDate = async (
maintenance) =>
{
  const updated = await fetchRequest.put(
    '/maintenance/nextToDate/fill',
    convertDataToServer(maintenance)
  );
  if (updated) return updated;
  throw new Error('Не удалось проставить день следующего ТО');
};

export const printSchedule = async (params, filename) => {
  const print = await downloadRequestWithToken(
    `/maintenance/printSchedule`,
    params,
    filename
  );
  if (print) return print;
  throw new Error('Не удалось загрузить файл');
};

export const getForVehicle = async (
vehicleId) =>
{
  const data = await fetchRequest.get(
    `/maintenance/getForVehicle/${vehicleId}`
  );
  if (data)
  return {
    data: data.data.map((el) => convertDataFromServer(el)),
    maintenanceCosts: convertFromKopToRub(data.maintenanceCosts)
  };

  throw new Error('Не удалось получить ремонты');
};

export default {
  changeCountStockPart,
  groupedList,
  print,
  getTotalSum,
  updateAct,
  getMaintenanceExpenseDirection,
  printMaintenance,
  addMaintenance,
  fetchMaintenance,
  updateMaintenance,
  deleteMaintenance,
  changeStatusMaintenance,
  fetchMaintenances,
  fillNextToDate,
  printSchedule,
  getForVehicle
};
